import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import { toRefs, ref, onMounted, onUnmounted } from 'vue'
import DropdownHeaderMapMenu from '@/components/general/selectors/DropdownMapMenu/DropdownHeaderMapMenu.vue'
import DropdownCheckboxRowMapMenu from '@/components/general/selectors/DropdownMapMenu/checkbox/DropdownCheckboxRowMapMenu.vue'
export type optionType = {
  id: string
  checked: boolean
  value: string
  color?: string
  iconSource?: string
  isHeading?: boolean
}
interface Props {
  title: string
  options: optionType[]
  preventCloseElementIds?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownCheckboxMapMenu',
  props: {
    title: {},
    options: {},
    preventCloseElementIds: { default: () => [] }
  },
  emits: ["toggleOption"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { title, options, preventCloseElementIds } = toRefs(props)

const isOpen = ref(false)
const dropdownRef = ref<HTMLElement | null>(null)
onMounted(() =>
  document.addEventListener('click', (event: MouseEvent | PointerEvent) => close(event))
)
onUnmounted(() =>
  document.removeEventListener('click', (event: MouseEvent | PointerEvent) => close(event))
)
const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}
const onToggleOption = (id: string) => {
  emits('toggleOption', id)
}
const close = (event: MouseEvent | TouchEvent) => {
  const element = event.target as HTMLElement
  if (preventCloseElementIds.value.includes(element.id)) return
  const target = event.target as HTMLElement
  if (!dropdownRef.value?.contains(target)) isOpen.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: "dropdown"
  }, [
    _createVNode(DropdownHeaderMapMenu, {
      title: _unref(title),
      isOpen: isOpen.value,
      onToggle: toggleDropdown
    }, null, 8, ["title", "isOpen"]),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown-content", { open: isOpen.value }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (option) => {
        return (_openBlock(), _createBlock(DropdownCheckboxRowMapMenu, {
          id: option.id,
          key: option.id,
          checked: option.checked,
          value: option.value,
          circleColor: option.color,
          iconSource: option.iconSource,
          isHeading: option.isHeading,
          onToggleOption: onToggleOption
        }, null, 8, ["id", "checked", "value", "circleColor", "iconSource", "isHeading"]))
      }), 128))
    ], 2)
  ], 512))
}
}

})